import { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

export function Portal(props) {
  const { children } = props
  const container = useRef(document.createElement('div'))

  useEffect(() => {
    const element = container.current

    element.classList.add('portal')
    document.body.appendChild(element)
    return () => {
      document.body.removeChild(element)
    }
  }, [container])

  return ReactDOM.createPortal(
    <div
      role="none"
      onClick={e => {
        e.stopPropagation()
      }}
    >
      {children}
    </div>,
    container.current
  )
}
